import { useState } from 'react';
import { TOAST_TYPES } from '../ui/notification';

export type TNotification = {
  id: number;
  title: string;
  message: string;
  type?: TOAST_TYPES;
  size?: string;
  timeout?: number;
};

export const useNotification = () => {
  const [notifications, setNotifications] = useState<TNotification[]>([]);

  // * Adds notification to notifications list
  const addNotification = (notification: TNotification) => {
    setNotifications((prevState) => {
      return [...prevState, notification];
    });
  };

  // * Removes notification with the given id from notifications list
  const removeNotification = (id: number) => {
    setNotifications((prevState) => {
      return prevState.filter((notification) => notification.id !== id);
    });
  };

  return { notifications, addNotification, removeNotification };
};
